import React from 'react'
import styled from 'styled-components'

import SectionComponent from './Section'
import Heading1Component from './Heading1'
import ParagraphComponent from './Paragraph'

const Section = styled(SectionComponent)`
  flex-grow: 1;
  background-color: white;
`

const Content = styled.div`
  max-width: 1000px;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 768px) {
    justify-content: space-between;
    align-items: flex-start;
  }
`

const Heading1 = styled(Heading1Component)`
  color: #333333;
  max-width: 540px;
`

const Paragraph = styled(ParagraphComponent)`
  color: #333333;
  max-width: 540px;
`
// const StovnerLogo = styled.img`
//   max-width: 100px;
// `

const Why = () => (
  <Section>
    <Content>
      <Heading1>Hva er Spir?</Heading1>
      <Paragraph>
        I Norge har vi lav arbeidsledighet, men likevel kan det være vanskelig å få jobb. Særlig som ungdom.
        Sånn trenger det ikke å være. Det er nemlig masse behov for dere, men informasjon om jobber og oppdrag
        stopper opp fordi det ikke finnes noe sted å dele det med dere på en enkel måte. Frem til nå.
      </Paragraph>
      <Paragraph>
        På Spir skal det være lett å oppdage jobber som interesserer deg, og det skal være enkelt å melde interesse.
        Du trenger ikke CV og du skriver ikke søknad. I stedet har du en digital profil du oppdaterer med jobberfaring
        og det som interesserer deg. Profilene kan oppdragsgivere besøke og ta kontakt med deg om jobb. Eller omvendt,
        at du kontakter dem.
      </Paragraph>
      <Paragraph>
        Fast jobb eller kort oppdrag. Ute eller inne. Lite eller mye. Du bestemmer, du er sjefen.
      </Paragraph>
      {/* <Paragraph>
        I samarbeid med <StovnerLogo src="/stovner-logo.jpg" alt="Bydel Stovner" />
      </Paragraph> */}
    </Content>
  </Section>
)

export default Why



// WEBPACK FOOTER //
// ./src/pages/Landing/Why.js